module.exports = __webpack_public_path__ + "static/media/plantTen.3f109bf8.jpg";